// Mobile menu
// Triggers the mobile menu when its larger than it's parent
let parentWidth = 0;
let groups = {};
let originalMenuWidth = 0;
let menuSwitched = null;
let clickEvent = 'click';
let mobileMenuEnabled = (isMobile ? true : null);
let lockedMobile = false;

$(document).ready(function () {

    // Generate groups by their groupId set by elements using menu-group
    $('[data-menu-group]').each(function () {
        let $this = $(this),
            groupId = $this.attr('data-menu-group');

        if (groupId in groups) {
            groups[groupId] = groups[groupId].add($this);
        } else {
            groups[groupId] = $this;
        }
    });

    // Function for each group
    $.each(groups, function (index, group) {

        if (isMobile) {
            enableMobile(true);
        } else {
            mobileMenu(index, group);
        }

        $(window).resize('resize', function () {
            mobileMenu(index, group);
        });

    });

    // Toggle mobile menu
    if ('ontouchstart' in window) {
        clickEvent = 'touchstart';
    }

    $('.btn-mobile-menu').on(clickEvent, function () {
        if (!$(this).hasClass('opened')) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    // Mobile submenu
    $('.header-section.mobile .submenu > a').on('click', function (e){
        e.preventDefault();
        $(this).parent().find('.layer-2').toggle();
    });

    // check locked
    if ($('.mobile-locked').length) {
        lockedMobile = true;
    }
});

// Measure menu + header on resize
function mobileMenu(index, group) {

    parentWidth = $('[data-menu-group="' + index + '"][data-menu-measure="parent"]').width();
    let menuWidth = 20;
    let showMobile = null;

    $('[data-menu-group="' + index + '"][data-menu-measure="child"]').each(function () {
        menuWidth += $(this).outerWidth();
    });


    if (menuSwitched === true) {
        if (originalMenuWidth >= parentWidth) {
            showMobile = true;
        } else {
            showMobile = false;
        }
    } else {
        if (menuWidth >= parentWidth) {
            menuSwitched = true;
            originalMenuWidth = menuWidth;
            showMobile = true;
        } else {
            showMobile = false;
        }
    }

    if (showMobile) {
        enableMobile();
    } else {
        disableMobile();
    }

}

function enableMobile(forced) {

    if (forced === true) {
        let mobileSection = $('.mobile-menu > ul');

        // move elemets to the mobile section
        $('[data-menu-target="mobile-menu"]').sort(function(a, b) {
            return +a.dataset.menuPosition - +b.dataset.menuPosition;
        }).each(function () {
            let content = $(this).children().first();
            let menuName = $(this).data('menuName');
            let li = $('<li/>').addClass(menuName).attr('data-menu-revert', menuName);
            li.append(content);
            li.appendTo(mobileSection);
        });

        return true;
    }

    if (mobileMenuEnabled !== true) {
        $('.header-section').addClass('mobile');

        let mobileSection = $('.mobile-menu > ul');

        // move elemets to the mobile section
        $('[data-menu-target="mobile-menu"]').sort(function(a, b) {
            return +a.dataset.menuPosition - +b.dataset.menuPosition;
        }).each(function () {
            let content = $(this).children().first();
            let menuName = $(this).data('menuName');
            let li = $('<li/>').addClass(menuName).attr('data-menu-revert', menuName);
            li.append(content);
            li.appendTo(mobileSection);
        });
    }

    mobileMenuEnabled = true;

}

function disableMobile() {

    // lock into mobile on mobile-devices
    if (lockedMobile) {
        return false;
    }

    if (mobileMenuEnabled === true) {
        $('.header-section').removeClass('mobile');

        // move elements back
        $('.mobile-menu > ul > li').each(function () {
            let content = $(this).children().first();
            let target = $('[data-menu-name="'+$(this).data('menuRevert')+'"]');
            content.appendTo(target);
            $(this).remove();
        });

        mobileMenuEnabled = false;
    }

}

function openMenu() {
    $('.header-section').addClass('expand');
    $('.btn-mobile-menu').addClass('opened');

    // hamburger animation
    $('div.x, div.y, div.z').addClass('collapse');

    setTimeout(function () {
        $('div.y').hide();
        $('div.x').addClass('rotate30');
        $('div.z').addClass('rotate150');
    }, 70);
    setTimeout(function () {
        $('div.x').addClass('rotate45');
        $('div.z').addClass('rotate135');
    }, 120);
}

function closeMenu() {
    $('.header-section').removeClass('expand');
    $('.btn-mobile-menu').removeClass('opened');

    // hamburger animation
    $('div.x').removeClass('rotate45').addClass('rotate30');
    $('div.z').removeClass('rotate135').addClass('rotate150');
    setTimeout(function () {
        $('div.x').removeClass('rotate30');
        $('div.z').removeClass('rotate150');
    }, 50);
    setTimeout(function () {
        $('div.y').show();
        $('div.x, div.y, div.z').removeClass('collapse');
    }, 70);
}
